import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";

export const useGetCollection = (collectionId: string, t?: number) => {

    const [collection, setCollection] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);

    useEffect(() => {
        if (collectionId) {
            setIsLoading(true);
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Collection/Get')
                .addQuery('id', collectionId)
                .get()
                .send()
                .then((r) => r.json())
                .then((r) => {
                    setIsLoading(false);
                    if (r?.cardCollectionId) setCollection(r)
                })
                .catch((e) => {
                    setIsLoading(false);
                    setError(true);
                })
        }
    }, [collectionId, t])

    return {collection, isLoading, error}
}import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";

export const useGetCollection = (collectionId: string, t?: number) => {

    const [collection, setCollection] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);

    useEffect(() => {
        if (collectionId) {
            setIsLoading(true);
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Collection/Get')
                .addQuery('id', collectionId)
                .get()
                .send()
                .then((r) => r.json())
                .then((r) => {
                    setIsLoading(false);
                    if (r?.cardCollectionId) setCollection(r)
                })
                .catch((e) => {
                    setIsLoading(false);
                    setError(true);
                })
        }
    }, [collectionId, t])

    return {collection, isLoading, error}
}